import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function DeleteCircleFill({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" fillRule="evenodd" clipRule="evenodd" d="M2.25 12C2.25 6.6053 6.61527 2.25 12 2.25C17.3852 2.25 21.75 6.61479 21.75 12C21.75 17.3852 17.3852 21.75 12 21.75C6.6053 21.75 2.25 17.3847 2.25 12ZM9.70025 8.63971C9.40736 8.34682 8.93249 8.34682 8.63959 8.63971C8.3467 8.93261 8.3467 9.40748 8.63959 9.70037L10.9393 12L8.63959 14.2997C8.3467 14.5926 8.3467 15.0675 8.63959 15.3604C8.93249 15.6533 9.40736 15.6533 9.70025 15.3604L11.9999 13.0607L14.2996 15.3604C14.5925 15.6533 15.0674 15.6533 15.3603 15.3604C15.6531 15.0675 15.6531 14.5926 15.3603 14.2997L13.0606 12L15.3603 9.70037C15.6531 9.40748 15.6531 8.93261 15.3603 8.63971C15.0674 8.34682 14.5925 8.34682 14.2996 8.63971L11.9999 10.9394L9.70025 8.63971Z" fill="currentColor" /></Svg>;
}
export default DeleteCircleFill;